import { CreateMortgageLeadTassoCommand } from '@tassomutuo-backoffice/types';

import type { CapAutocompleteCity } from '../../../components';
import { acquisitionAmountToNumber } from '../acquisition/acquisitionAmount';
import {
  ACQUISITION_DEFAULT_PHONE_COUNTRY,
  acquisitionPhonePrefix,
} from '../acquisition/AcquisitionPhonePrefixSelect';
import type { LeadTassoUnder36Choice } from './leadTassoOptions';

/**
 * The draft an operator compiles. It is not the request body: the phone
 * country, the display grouping of the amounts and the under-36 wording only
 * exist on screen, and `buildCommand` is the single place they are dropped.
 */
export interface LeadTassoFormValues {
  purpose: CreateMortgageLeadTassoCommand['purpose'] | '';
  propertyValue: string;
  loanAmount: string;
  durationYears: string;
  under36Choice: LeadTassoUnder36Choice | '';
  rateType: CreateMortgageLeadTassoCommand['rateType'] | '';
  firstName: string;
  lastName: string;
  email: string;
  /** ISO2 of the selected country; only its `+NN` prefix is sent. */
  phoneCountry: string;
  phone: string;
  location: CapAutocompleteCity | null;
  sendWelcomeCommunication: boolean;
}

export const LEAD_TASSO_DEFAULT_VALUES: LeadTassoFormValues = {
  purpose: '',
  propertyValue: '',
  loanAmount: '',
  durationYears: '',
  under36Choice: '',
  rateType: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneCountry: ACQUISITION_DEFAULT_PHONE_COUNTRY,
  phone: '',
  location: null,
  sendWelcomeCommunication: false,
};

export const buildLeadTassoCommand = (
  data: LeadTassoFormValues
): CreateMortgageLeadTassoCommand => ({
  purpose: data.purpose as CreateMortgageLeadTassoCommand['purpose'],
  propertyValue: acquisitionAmountToNumber(data.propertyValue) as number,
  loanAmount: acquisitionAmountToNumber(data.loanAmount) as number,
  durationYears: Number(
    data.durationYears
  ) as CreateMortgageLeadTassoCommand['durationYears'],
  under36: data.under36Choice === 'si',
  rateType: data.rateType as CreateMortgageLeadTassoCommand['rateType'],
  firstName: data.firstName.trim(),
  lastName: data.lastName.trim(),
  location: {
    comune: data.location?.nome ?? '',
    cap: data.location?.cap ?? '',
    provincia: data.location?.provincia ?? '',
    regione: data.location?.regione ?? '',
  },
  email: data.email.trim(),
  phonePrefix: acquisitionPhonePrefix(data.phoneCountry),
  phone: data.phone.trim(),
  sendWelcomeCommunication: data.sendWelcomeCommunication,
});
